import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { makeStyles, Theme } from '@material-ui/core/styles';

import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import DateRangeIcon from '@material-ui/icons/DateRange';

import Fab from 'components/@common/Fab';
import { VoidCallback } from 'types';
import PreviewListHeaderContainer from 'components/ResourcesModule/components/PreviewListHeaderContainer';

const useStyles = makeStyles((theme: Theme) => {
  return {
    weekDisplayText: {
      marginRight: theme.spacing(3),
      marginLeft: theme.spacing(3)
    },
    fab: {
      background: 'white',
      boxShadow: 'unset',
      border: '1px solid #969696',
      color: '#969696',
      '&:hover': {
        background: 'white'
      }
    }
  };
});

type WeekHeaderProps = {
  week: string | undefined;
  keys: string[] | undefined;
  thumbnail: string | undefined;
  theme: any;
  onNavigateToWeeksView: VoidCallback;
  onWeekChange: (value: number) => void;
};

const WeekHeader: React.FC<WeekHeaderProps> = ({
  week,
  keys,
  theme,
  thumbnail,
  onNavigateToWeeksView,
  onWeekChange
}) => {
  const classes = useStyles();

  const handleWeekForward = () => onWeekChange(1);
  const handleWeekBackward = () => onWeekChange(-1);

  return (
    <PreviewListHeaderContainer
      title={theme?.name}
      chip={{ text: `Week ${week}`, backgroundColor: '#8A73B2' }}
      subtitle={keys?.length ? `Keys: ${keys}` : undefined}
      imageSrc={thumbnail}
    >
      <Grid item container justify="flex-end" alignItems="center" xs={12} md={6}>
        <Grid item container alignItems="center" justify="flex-end">
          <Fab
            variant="contained"
            color="primary"
            startIcon={<KeyboardArrowLeftIcon />}
            onClick={handleWeekBackward}
            className={classes.fab}
          />
          <Typography variant="h3" className={classes.weekDisplayText}>
            Week {week}
          </Typography>
          <Fab
            variant="contained"
            color="primary"
            startIcon={<KeyboardArrowRightIcon />}
            onClick={handleWeekForward}
            className={classes.fab}
          />
        </Grid>
        <Grid item container alignItems="center" justify="flex-end">
          <Button
            onClick={onNavigateToWeeksView}
            variant="text"
            size="small"
            startIcon={<DateRangeIcon />}
            disableElevation
          >
            View All 36 Week Preview
          </Button>
        </Grid>
      </Grid>
    </PreviewListHeaderContainer>
  );
};

export default WeekHeader;
